var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import R from '../../../../core-res/R';
import DRNInputField from '../../../InputField';
import DRNButton from '../../../Button/DRNButton';
import DRNImage from '../../../Image/DRNImage';
import DRNTouchableWrapper from '../../../Button/TouchableButtonWrapper';
import { DRNUtil } from '@traveloka/district-util';
import { withTheme } from '../../../../theme';
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        height: DRNUtil.getNavBarHeight(),
        alignItems: 'center',
        paddingLeft: R.spacing.s,
        paddingRight: R.spacing.xs,
    },
    chevron: {
        width: 24,
        height: 24,
        marginRight: R.spacing.s,
        transform: [{ rotateZ: '-90deg' }],
    },
});
class InputField extends PureComponent {
    render() {
        const _a = this.props, { closeText, onClose, size, theme, onBackButtonPress, backgroundColor, smartKey } = _a, restProps = __rest(_a, ["closeText", "onClose", "size", "theme", "onBackButtonPress", "backgroundColor", "smartKey"]);
        return (<View style={[styles.container, { backgroundColor: backgroundColor || theme.brand }]}>
        {onBackButtonPress && (<DRNTouchableWrapper onPress={onBackButtonPress}>
            <DRNImage style={[styles.chevron, { tintColor: theme.lightPrimary }]} resizeMode="contain" source={require('../../../../../images/ic-sys-chevron-up.png')}/>
          </DRNTouchableWrapper>)}
        <View style={{ flex: 1 }}>
          <DRNInputField {...restProps} smartKey={{
            accessibilityLabel: smartKey,
        }} variant={DRNInputField.VARIANT_STANDARD} size="small" iconLeft={require('../../../../../images/ic_search.png')}/>
        </View>
        <DRNButton text={closeText} onPress={onClose} size={size} variant={DRNButton.VARIANT.TEXT_WHITE} style={{ marginLeft: R.spacing.xs, minWidth: 56 }}/>
      </View>);
    }
}
InputField.propTypes = {
    backgroundColor: PropTypes.string,
    closeText: PropTypes.string,
    onBackButtonPress: PropTypes.func,
    onClose: PropTypes.func,
    theme: PropTypes.object,
};
InputField.defaultProps = {
    closeText: 'Close',
};
export default withTheme(InputField);
